import type { ColPresetType } from '../../../redux/clientConfiguration/clientConfigurationSlice';
import type { DashboardWidgetType } from '../../dashboard/Dashboard.types';
import type { PresetsByPage } from './types';

export const isRecord = (value: unknown): value is Record<string, unknown> =>
	!!value && typeof value === 'object' && !Array.isArray(value);

/** A stored widget list without non-object entries, or null if not a list. */
export const toWidgetList = (value: unknown): DashboardWidgetType[] | null =>
	Array.isArray(value)
		? (value.filter(isRecord) as unknown as DashboardWidgetType[])
		: null;

export const isPreset = (value: unknown): value is ColPresetType =>
	isRecord(value) &&
	typeof value.name === 'string' &&
	Array.isArray(value.columns);

/** Valid presets per page from a stored `columns` value, or null if not an object. */
export const toPresetsByPage = (value: unknown): PresetsByPage | null => {
	if (!isRecord(value)) return null;
	const byPage: PresetsByPage = {};
	for (const [page, list] of Object.entries(value)) {
		if (Array.isArray(list)) byPage[page] = list.filter(isPreset);
	}
	return byPage;
};
